import {Maximize} from "lucide-react";
import {CloseCircleOutlined, CloudUploadOutlined, PictureOutlined} from "@ant-design/icons";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import UploadAvatarModal from "../models/UploadAvatarModel/UploadAvatarModal";
import {APIv1} from "../../../api";
import "./ShowUserPicture.scss"

export default function ShowUserPicture({data, inn, userToken, isEditing=true, uploadPlacement = "preview"}) {
    const {t} = useTranslation();
    const [fullscreenImage, setFullscreenImage] = useState(null);
    const [fullscreenImageId, setFullscreenImageId] = useState(null);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [selectedUploadImageId, setSelectedUploadImageId] = useState(null);

    const showCardUploadButton = isEditing && uploadPlacement === "card";
    const showPreviewUploadButton = isEditing && uploadPlacement === "preview";

    const openFullscreen = (imageSrc, imageId) => {
        setFullscreenImage(imageSrc);
        setFullscreenImageId(imageId);
    };

    const closeFullscreen = () => {
        setFullscreenImage(null);
        setFullscreenImageId(null);
    };

    const handleOpenUploadModal = (imageId) => {
        setSelectedUploadImageId(imageId);
        setIsUploadModalOpen(true);
    };

    const handleUpload = async (file, imageId) => {
        const formData = new FormData();

        formData.append("image_file", file.originFileObj);
        formData.append("image_type", imageId);
        formData.append("inn", inn);

        const response = await APIv1.put('/company/profile/images/update/',
            formData,
            {
                headers: {
                    Authorization: `Token ${userToken}`,
                }
            });
        return response?.data.status === "successfully";
    };

    const defaultProfilePictures = [
        {
            id: 'billing',
            divClassName: 'billing-picture',
            srcClassName: 'billing-img',
            src: data.billingLogo,
            alt: 'Billing',
            label: t("pages.user.profile.avatar1")
        },
        {
            id: 'qrLogo',
            divClassName: 'qr-logo',
            srcClassName: null,
            src: data.logo,
            alt: 'scan2pay logo',
            label: t("pages.user.profile.avatar2")
        },
        {
            id: 'qrBanner',
            divClassName: 'qr-banner',
            srcClassName: null,
            src: data.banner,
            alt: 'scan2pay banner',
            label: t("pages.user.profile.avatar3")
        },
    ];

    return (
        <>
            {defaultProfilePictures.map((picture) => (
                <div
                    key={picture.id}
                    className={picture.divClassName}
                    onClick={() => openFullscreen(picture.src, picture.id)}
                >
                    {picture.src ? (
                        <img className={picture.srcClassName} src={picture.src} alt={picture.alt}/>
                    ) : (
                        <div className="no-image-placeholder">
                            <PictureOutlined style={{fontSize: 40, color: "#bbb"}}/>
                        </div>
                    )}
                    <div className="profile-picture__footer">
                        <span className="profile-picture__label">{picture.label}</span>
                        <div className="profile-picture__actions">
                            <div className="hover-overlay">
                                <Maximize size={24} color={'#3f96ff'}/>
                            </div>
                            {showCardUploadButton ? (
                                <button
                                    className="profile-picture__upload-button"
                                    type="button"
                                    aria-label={`Upload ${picture.label}`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleOpenUploadModal(picture.id);
                                    }}
                                >
                                    <span>{t("pages.user.profile.buttons.button4")}</span>
                                    <CloudUploadOutlined/>
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            ))}
            {fullscreenImageId && (
                <div className="fullscreen-image" onClick={closeFullscreen}>
                    {fullscreenImage ? (
                        <img src={fullscreenImage} alt="Full-screen view"/>
                    ) : (
                        <div className="no-image-placeholder">
                            <PictureOutlined style={{fontSize: 40, color: "#bbb"}}/>
                        </div>
                    )}
                    <div className="user_image__action-buttons">
                        {showPreviewUploadButton ? (
                            <CloudUploadOutlined
                                style={{fontSize: 24}}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenUploadModal(fullscreenImageId);
                                }}
                            />
                        ) : null}
                        <CloseCircleOutlined
                            style={{fontSize: 24}}
                            onClick={(e) => {
                                e.stopPropagation();
                                closeFullscreen();
                            }}
                        />
                    </div>
                </div>
            )}
            <UploadAvatarModal
                open={isUploadModalOpen}
                onClose={() => setIsUploadModalOpen(false)}
                onUpload={handleUpload}
                imageId={selectedUploadImageId}
            />
        </>
    );
}
